import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ 
    providedIn: 'root' 
})

export class ScrollControlService {
  private scrollEnabledSubject = new BehaviorSubject<boolean>(true);
  scrollEnabled$ = this.scrollEnabledSubject.asObservable();

  setScroll(enabled: boolean) {
    this.scrollEnabledSubject.next(enabled);
  }
}
